import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import MaritalStatusModalPage from '../../../containers/masters/MaritalStatus/MaritalStatusModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class MaritalStatusMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        nameDescription: null,
        code: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchMaritalStatusList()
  }

  componentDidUpdate () {
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchMaritalStatusList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchMaritalStatusList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  search () {
    this.props.actions.fetchMaritalStatusList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  handleNameDescriptionChange (nameDescription) {
    if (this.state.filter.nameDescription !== nameDescription) {
      this.setState({ filter: { ...this.state.filter, nameDescription } })
    }
  }

  handleCodeChange (code) {
    if (this.state.filter.code !== code) {
      this.setState({ filter: { ...this.state.filter, code } })
    }
  }

  resetFilters () {
    this.props.initialize({})
    this.props.reset()
    this.setState({
      filter: {
        code: null,
        nameDescription: null
      }
    })
    this.props.actions.fetchMaritalStatusList({ pageSize: 10 })
  }

  restart (maritalStatus) {
    maritalStatus.isEnabled = true
    this.props.actions.submitMaritalStatus(maritalStatus)
    this.resetFilters()
  }

  render () {
    const {
      t, maritalStatusList, pagesCount, maritalStatusListCount, filter,
      filter: { page },
      actions: { fetchMaritalStatusList, deleteMaritalStatus }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'maritalStatusMasterPage' })
    const tKey = 'MASTERS.MARITAL_STATUS_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    const hasFilters = (this.state.filter.nameDescription || this.state.filter.code)
    return (
      <div id='maritalStatusMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => this.props.actions.openMaritalStatusModal()}>
              <i className='iDocIcon-add-plus'></i>{t(`${tKey}ADD`)} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.code"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                onInputChange={(value) => this.handleCodeChange(value)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.nameDescription"
                controlLabel={t(`${tKey}NAME_DESCRIPTION`)}
                placeholder={t(`${tKey}NAME_DESCRIPTION`)}
                onInputChange={(value) => this.handleNameDescriptionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.search()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(maritalStatusList.length !== 0) &&
          <Table className="editable-table" hover responsive>
            <thead>
              <tr>
                <th onClick={() => { this.changeOrder('code') }}>
                  {t(`${tKey}CODE`)}
                  <i className={this.getSortIcon('code')} />
                </th>
                <th onClick={() => { this.changeOrder('name') }}>
                  {t(`${tKey}NAME`)}
                  <i className={this.getSortIcon('name')} />
                </th>
                <th onClick={() => { this.changeOrder('description') }}>
                  {t(`${tKey}DESCRIPTION`)}
                  <i className={this.getSortIcon('description')} />
                </th>
                <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {maritalStatusList && maritalStatusList.map((maritalStatus, idx) => {
                return (
                  <tr key={idx} className={!maritalStatus.isEnabled ? 'is-deleted' : ''}>
                    <td>{maritalStatus.code}</td>
                    <td>{maritalStatus.name}</td>
                    <td>{maritalStatus.description}</td>
                    <td className='actions'>
                      {maritalStatus.isEnabled ? (
                        <div>
                          <OverlayTrigger placement="left" overlay={editTooltip}>
                            <a className='_Btn accept stk o-icn ' onClick={() => this.props.actions.openEditMaritalStatusModal(maritalStatus)}>
                              <i className="iDocIcon-edit" />
                            </a>
                          </OverlayTrigger>
                          <OverlayTrigger placement="left" overlay={deleteTooltip}>
                            <a className='_Btn cancel stk o-icn ' onClick={() => deleteMaritalStatus(maritalStatus.maritalStatusId)}>
                              <i className="iDocIcon-delete-forever" />
                            </a>
                          </OverlayTrigger>
                        </div>
                      ) : (
                        <div>
                          <OverlayTrigger placement="left" overlay={recoverTooltip}>
                            <a className='_Btn accent stk o-icn ' onClick={() => this.restart(maritalStatus)}>
                              <i className='iDocIcon-undo-back' />
                            </a>
                          </OverlayTrigger>
                        </div>
                      )}
                    </td>
                  </tr>)
              })}
            </tbody>
          </Table>
              }
              {(maritalStatusList === null || maritalStatusList === undefined || maritalStatusList.length === 0) &&
            <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={maritalStatusListCount}
                    onSelectAction={(value) => fetchMaritalStatusList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <MaritalStatusModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listMaritalStatus'
})(MaritalStatusMaster)
